import { useTranslation } from 'react-i18next';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { Sun, Moon } from 'lucide-react';
import { useUIStore } from '@/shared/stores/uiStore';
import { cn } from '@/shared/lib/utils';

export function ThemeToggle() {
  const { t } = useTranslation();
  const theme = useUIStore((s) => s.theme);
  const setTheme = useUIStore((s) => s.setTheme);

  const isDark =
    theme === 'dark' ||
    (theme === 'system' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <SwitchPrimitives.Root
      checked={isDark}
      onCheckedChange={(checked) => { setTheme(checked ? 'dark' : 'light'); }}
      aria-label={t(`theme.${theme}`)}
      className={cn(
        'relative inline-flex h-8 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        isDark ? 'bg-slate-700' : 'bg-slate-300'
      )}
    >
      <SwitchPrimitives.Thumb
        className={cn(
          'flex h-6 w-6 items-center justify-center rounded-full shadow-md transition-all duration-300',
          isDark
            ? 'translate-x-6 bg-slate-900 text-amber-300'
            : 'translate-x-0 bg-white text-amber-500'
        )}
      >
        {isDark ? (
          <Moon className="h-3.5 w-3.5" strokeWidth={2} />
        ) : (
          <Sun className="h-3.5 w-3.5" strokeWidth={2} />
        )}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  );
}
